module.exports = __webpack_public_path__ + "img/fi-street-food-200x132.17d2a108.jpg";